<template>
  <div class="card" v-if="totalLiveStreamPage > 0">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          <h3 class="mb-0">Live Stream Info</h3>
        </div>
        <!-- <div class="col text-right">
          <a href="#!" class="btn btn-sm btn-primary">See all</a>
        </div>-->
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        :data="liveStreams"
        @onRowClicked="onRowClicked"
        :clickableRow="true"
      >
        <template slot="columns">
          <th>Streamer Name</th>
          <th>Title</th>
          <th>Description</th>
          <!-- <th v-if="!isAdmin">Streaming URL</th>
          <th v-if="!isAdmin">Stream Key</th>-->
          <th>Total Comments</th>
          <th>Total Views</th>
          <th>Created Date</th>
          <th>Status</th>
        </template>

        <template slot-scope="{ row }">
          <td>{{ row.streamer.name }}</td>
          <td class="text-overflow">{{ row.title }}</td>
          <td class="text-overflow">{{ row.description }}</td>
          <!-- <td v-if="!isAdmin">{{ getStreamingUrl(row.streamer.appName) }}</td>
          <td v-if="!isAdmin">{{ row.streamKey }}</td>-->
          <td>{{ format(row.commentCount) }}</td>
          <td>{{ format(row.views) }}</td>
          <td>{{ formatDate(row.createdDate) }}</td>
          <td
            :class="{
              'status-live': row.status === 'live',
              'status-pending':
                row.status === 'pending' || row.status === 'preparing',
              'status-ended': row.status === 'ended'
            }"
          >
            {{ capitalize(row.status) }}
          </td>
          <!-- <td style="margin: 3rem 0">
            <div
              class="text-center"
              style="background: #000000; padding: .5rem 0"
            >{{ capitalize(row.status) }}</div>
          </td>-->
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination
          :page-count="totalLiveStreamPage"
          v-model="pagination"
          @input="onPageChanged"
        ></base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

import { mapState, mapGetters } from "vuex";
import { GET_LIVE_STREAMS } from "@/store/actions.type";

import Progress from "@/common/progress";
import { formatNumber } from "@/common/utils";

export default {
  name: "live-stream-info-table",
  data() {
    return {
      pagination: 1
    };
  },
  mounted() {
    this.$store.dispatch(GET_LIVE_STREAMS, 1);
  },
  methods: {
    onPageChanged(page) {
      Progress.show();
      this.$store
        .dispatch(GET_LIVE_STREAMS, page)
        .then(() => Progress.hide())
        .catch(() => Progress.hide());
    },
    format(number) {
      return formatNumber(number);
    },
    capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    onRowClicked(index) {
      const liveStream = this.liveStreams[index];
      this.$router.push({ path: "live_stream/" + liveStream.id });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY hh:mm A");
    }
  },
  computed: {
    ...mapState({
      error: state => state.liveStream.error
    }),
    ...mapGetters(["totalLiveStreamPage", "liveStreams", "isAdmin"])
  }
};
</script>
<style scoped>
.table th,
.table td {
  border-top: 0.5px solid rgba(220, 220, 220, 0.3) !important;
}

.text-overflow {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.status-live {
  color: #2dce89 !important;
  font-weight: bold;
}
.status-pending {
  color: #962100 !important;
  font-weight: bold;
}
.status-ended {
  color: #f5365c !important;
  font-weight: bold;
}
.btn-success {
  padding: 0.45rem 0.9rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
</style>
